export default __webpack_public_path__ + "static/media/blog-img79.efee5c45.jpg";